module.exports = __webpack_public_path__ + "1.5.0-unryo/img/ceph.80943bfe.png";